<template>
    <div class="flex-col" :class="[widthClass, ...(zone.class || [])]">
        <TgpItem v-for="(item, position) in zone.items"
                 :key="position + '-' + item.id"
                 :item="item"
                 :url-config="urlConfig"
        />
    </div>
</template>

<script>
import TgpItem from "./TgpItem";

export default {
    name: "TgpZone",
    components: {TgpItem},
    props: {
        zone: {type: Object, required: true},
        urlConfig: {type: Object, required: true},
    },

    computed: {
        widthClass() {
            return 'w-' + this.zone.width;
        },
    },
}
</script>

<style>
.flex-col {
    flex: 0 0 auto;
    /*padding: 0 2px;*/
}
.w-1\/3 {
    width: 33.333333%;
}
.w-2\/3 {
    width: 66.666667%;
}
.w-1\/4 {
    width: 25%;
}
.w-1\/2,
.w-2\/4 {
    width: 50%;
}
.w-3\/4 {
    width: 75%;
}
.w-full {
    width: 100%;
}

@media (min-width: 768px) {
    .gutters .flex-col {
        padding-left: 5px;
        padding-right: 5px;
    }
}

@media (min-width: 1024px) {
    .gutters .flex-col {
        padding-left: 10px;
        padding-right: 10px;
    }
}
</style>
